/* Bearly Art Tools hub — assets/tools-hub.js
 * GA4: sends through the store's own GA4 tag (see the GA4 block below),
 * ?debug_mode=1 for DebugView, respects Shopify customer privacy.
 * Events (prefix th_): th_view, th_search, th_filter, th_tool_click, th_shop_click,
 *                      th_demo_open, th_demo_step, th_ask_view, th_ask_dismiss, th_ask_submit
 * Email ask: same Klaviyo list, unlock keys and consent as the tool gate (bearly-tools-core.js),
 *            so one email here unlocks every tool and the library.
 */
(function () {
  'use strict';

  // ---------- GA4 ----------
  // The store's Google & YouTube app loads GA4 for this same ID on the main page
  // (window.dataLayer). Two copies of gtag.js for one ID conflict and one loses its
  // events, so send through the store's tag when it's there; load our own copy only
  // when it isn't. Respects Shopify customer privacy. ?debug_mode=1 for DebugView.
  var MEASUREMENT_ID = 'G-G0QSCXENNN';
  var DEBUG = /[?&]debug_mode=1\b/.test(location.search);
  window.thDataLayer = window.thDataLayer || [];
  window.dataLayer = window.dataLayer || [];
  function ownGtag() { window.thDataLayer.push(arguments); }
  function storeGtag() { window.dataLayer.push(arguments); }
  var ownLoaded = false, mode = null, queue = [], waitStart = 0;

  function analyticsAllowed() {
    try {
      var cp = window.Shopify && window.Shopify.customerPrivacy;
      if (cp && typeof cp.analyticsProcessingAllowed === 'function') return cp.analyticsProcessingAllowed();
    } catch (e) {}
    return true;
  }
  function loadOwn() {
    if (ownLoaded) return;
    ownLoaded = true;
    var s = document.createElement('script');
    s.async = true;
    s.src = 'https://www.googletagmanager.com/gtag/js?id=' + MEASUREMENT_ID + '&l=thDataLayer';
    document.head.appendChild(s);
    ownGtag('js', new Date());
    var cfg = { send_page_view: false };
    if (DEBUG) cfg.debug_mode = true;
    ownGtag('config', MEASUREMENT_ID, cfg);
  }
  function owner() {
    try { var g = window.google_tag_manager && window.google_tag_manager[MEASUREMENT_ID]; return (g && g.dataLayer && g.dataLayer.name) || ''; }
    catch (e) { return ''; }
  }
  function storeConfigured() {
    return window.dataLayer.some(function (i) { return i && typeof i === 'object' && i[0] === 'config' && i[1] === MEASUREMENT_ID; });
  }
  function storeOnPage() {
    return !!document.querySelector('script[src*="googletagmanager.com/gtag/js?id=' + MEASUREMENT_ID + '"]:not([src*="l="])');
  }
  function dispatch(name, params) {
    if (mode === 'store') storeGtag('event', name, Object.assign({ send_to: MEASUREMENT_ID }, params));
    else { loadOwn(); ownGtag('event', name, params); }
  }
  function resolve() {
    if (mode) return;
    var o = owner(), waited = Date.now() - waitStart;
    if (storeConfigured() || (o && o !== 'thDataLayer')) mode = 'store';
    else if (o === 'thDataLayer' || waited > (storeOnPage() ? 10000 : 5000)) mode = 'own';
    if (!mode) { setTimeout(resolve, 200); return; }
    var q = queue; queue = [];
    q.forEach(function (e) { dispatch(e[0], e[1]); });
  }

  function track(name, params) {
    params = params || {};
    window.dataLayer.push(Object.assign({ event: name }, params));
    if (!analyticsAllowed()) return;
    params.transport_type = 'beacon';
    if (DEBUG) params.debug_mode = true;
    if (DEBUG) console.log('[tools-hub]', name, params);
    if (mode) { dispatch(name, params); return; }
    queue.push([name, params]);
    if (!waitStart) { waitStart = Date.now(); resolve(); }
  }

  // ---------- Hub ----------
  var phoneMq = window.matchMedia('(max-width: 700px)');
  var hoverMq = window.matchMedia('(hover: hover)');
  var reduceMq = window.matchMedia('(prefers-reduced-motion: reduce)');
  function isPhone() { return phoneMq.matches; }

  function init() {
    var root = document.querySelector('[data-th]');
    if (!root) return;

    var grid = root.querySelector('[data-th-grid]');
    var form = root.querySelector('[data-th-form]');
    var input = root.querySelector('[data-th-input]');
    var sbtn = root.querySelector('[data-th-sbtn]');
    var chips = [].slice.call(root.querySelectorAll('[data-th-chip]'));
    var empty = root.querySelector('[data-th-empty]');
    var emptyTerm = root.querySelector('[data-th-empty-term]');
    var status = root.querySelector('[data-th-status]');
    var reset = root.querySelector('[data-th-reset]');
    var cards = [].slice.call(grid.querySelectorAll('[data-th-card]'));

    // ----- Order: sort_order on desktop, mobile_rank on phones; featured card always first -----
    function sortCards() {
      var key = isPhone() ? 'msort' : 'sort';
      cards.sort(function (a, b) {
        var fa = a.hasAttribute('data-th-feat') ? 0 : 1, fb = b.hasAttribute('data-th-feat') ? 0 : 1;
        if (fa !== fb) return fa - fb;
        return (parseInt(a.dataset[key], 10) || 999) - (parseInt(b.dataset[key], 10) || 999) ||
          a.dataset.name.localeCompare(b.dataset.name);
      });
      cards.forEach(function (c) { grid.insertBefore(c, empty); });
    }
    sortCards();

    var toolCount = cards.filter(function (c) { return !c.hasAttribute('data-th-feat'); }).length;

    function catsOf(card) { return (card.dataset.cats || '').split('|'); }

    // Hide chips that have no tools
    chips.forEach(function (chip) {
      var cat = chip.dataset.thChip;
      if (cat === 'all') return;
      chip.hidden = !cards.some(function (c) { return catsOf(c).indexOf(cat) > -1; });
    });

    var params = new URLSearchParams(location.search);
    var state = {
      cat: (params.get('cat') || 'all').toLowerCase(),
      q: params.get('q') || ''
    };
    if (!chips.some(function (c) { return c.dataset.thChip === state.cat && !c.hidden; })) state.cat = 'all';
    input.value = state.q;
    if (state.q && sbtn) openSearch(true);

    function visibleCards() { return cards.filter(function (c) { return !c.hidden; }); }

    function apply() {
      var terms = state.q.toLowerCase().split(/\s+/).filter(Boolean);
      var shown = 0, shownTools = 0;
      cards.forEach(function (card) {
        var inCat = state.cat === 'all' || catsOf(card).indexOf(state.cat) > -1;
        var hay = card.dataset.search || '';
        var match = inCat && terms.every(function (t) { return hay.indexOf(t) > -1; });
        card.hidden = !match;
        if (match) { shown++; if (!card.hasAttribute('data-th-feat')) shownTools++; }
      });
      chips.forEach(function (c) { c.setAttribute('aria-pressed', String(c.dataset.thChip === state.cat)); });
      empty.hidden = shown > 0 || cards.length === 0;
      emptyTerm.textContent = state.q ? '"' + state.q + '"' : 'this filter';
      var filtered = terms.length || state.cat !== 'all';
      status.textContent = filtered && shown ? 'Showing ' + shownTools + ' of ' + toolCount + ' tools' : '';
      watch();
      return shown;
    }

    function scrollToGrid() {
      var smooth = !reduceMq.matches;
      var target = root.querySelector('#tools') || grid;
      target.scrollIntoView({ behavior: smooth ? 'smooth' : 'auto', block: 'start' });
    }

    // ----- Search (phone: icon toggles the bar) -----
    function openSearch(open) {
      form.classList.toggle('is-open', open);
      if (sbtn) sbtn.setAttribute('aria-expanded', String(open));
      if (open) input.focus();
    }
    if (sbtn) sbtn.addEventListener('click', function () { openSearch(!form.classList.contains('is-open')); });

    var searchTimer;
    function trackSearch(results) {
      clearTimeout(searchTimer);
      if (state.q.trim().length < 2) return;
      searchTimer = setTimeout(function () {
        track('th_search', { search_term: state.q.trim().toLowerCase(), results: results, filter_category: state.cat });
      }, 900);
    }

    input.addEventListener('input', function () {
      state.q = input.value;
      trackSearch(apply());
    });

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      state.q = input.value;
      var n = apply();
      clearTimeout(searchTimer);
      if (state.q.trim()) track('th_search', { search_term: state.q.trim().toLowerCase(), results: n, filter_category: state.cat });
      scrollToGrid();
    });

    chips.forEach(function (chip) {
      chip.addEventListener('click', function () {
        state.cat = chip.dataset.thChip;
        var n = apply();
        track('th_filter', { filter_category: state.cat, results: n });
      });
    });

    reset.addEventListener('click', function () {
      state.q = '';
      state.cat = 'all';
      input.value = '';
      apply();
      input.focus();
    });

    // ----- Skip "drop your file here" frames: an empty upload box doesn't show what a tool does.
    // A frame whose caption starts with Drop / Load / Upload is hidden and the other two alternate.
    var UPLOAD_CAP = /^(\d+\s*·\s*)?(drop|load|upload|choose)\b/i;
    cards.forEach(function (c) {
      ['d', 'm'].forEach(function (k) {
        var cap = c.querySelector('.th__cap.th__' + k + '.th__f1');
        if (cap && UPLOAD_CAP.test(cap.textContent.trim())) c.classList.add('th__card--skip-' + k);
      });
    });

    // ----- Demo playback: hover on desktop, on-screen on phones -----
    var io = null;
    function play(card, on) { card.classList.toggle('is-playing', on); }
    function watch() {
      var demos = cards.filter(function (c) { return c.hasAttribute('data-demo') && !c.hidden; });
      if (io) { io.disconnect(); io = null; }
      if (reduceMq.matches) { demos.forEach(function (c) { play(c, false); }); return; }
      if (isPhone() || !hoverMq.matches) {
        if ('IntersectionObserver' in window) {
          io = new IntersectionObserver(function (entries) {
            entries.forEach(function (e) { play(e.target, e.isIntersecting && e.intersectionRatio > 0.6); });
          }, { threshold: [0, 0.6, 1] });
          demos.forEach(function (c) { io.observe(c); });
        }
      } else {
        demos.forEach(function (c) { play(c, false); });
      }
    }
    grid.addEventListener('mouseenter', function (e) {
      var card = e.target.closest && e.target.closest('[data-demo]');
      if (card && hoverMq.matches && !isPhone() && !reduceMq.matches) play(card, true);
    }, true);
    grid.addEventListener('mouseleave', function (e) {
      var card = e.target.closest && e.target.closest('[data-demo]');
      if (card && !isPhone()) play(card, false);
    }, true);

    // ----- "See how it works" viewer (desktop) -----
    var lb = root.querySelector('[data-th-lb]');
    var lbTitle = root.querySelector('[data-th-lb-title]');
    var lbSteps = root.querySelector('[data-th-lb-steps]');
    var lbImg = root.querySelector('[data-th-lb-img]');
    var lbUrl = root.querySelector('[data-th-lb-url]');
    var lbCap = root.querySelector('[data-th-lb-cap]');
    var lbGo = root.querySelector('[data-th-lb-go]');
    var cur = null, step = 0, lastFocus = null;

    function demoData(card) {
      var imgs = [].slice.call(card.querySelectorAll('.th__shots img.th__d'));
      var caps = [].slice.call(card.querySelectorAll('.th__cap.th__d'));
      var icon = card.querySelector('.th__tile img');
      return {
        card: card,
        name: card.dataset.name,
        url: card.dataset.url,
        link: card.dataset.link,
        color: card.dataset.color,
        icon: icon ? icon.currentSrc || icon.src : '',
        frames: imgs.map(function (i) { return { src: i.currentSrc || i.src, alt: i.alt }; }),
        steps: caps.map(function (c) { return c.textContent.replace(/^\d+\s*·\s*/, ''); })
      };
    }
    function drawLb() {
      if (!cur) return;
      lb.style.setProperty('--c', cur.color || '');
      lbTitle.innerHTML = (cur.icon ? '<img src="' + cur.icon + '" alt="">' : '') + '<span></span>';
      lbTitle.lastChild.textContent = cur.name;
      lbUrl.textContent = cur.url;
      lbImg.src = cur.frames[step].src;
      lbImg.alt = cur.frames[step].alt;
      lbCap.innerHTML = '<strong>Step ' + (step + 1) + ':</strong> ';
      lbCap.appendChild(document.createTextNode(cur.steps[step] || ''));
      lbGo.href = cur.link;
      lbGo.textContent = 'Open ' + cur.name;
      lbSteps.innerHTML = '';
      cur.steps.forEach(function (s, i) {
        var b = document.createElement('button');
        b.type = 'button'; b.className = 'th__lbbtn';
        b.setAttribute('aria-pressed', String(i === step));
        b.textContent = (i + 1) + '. ' + s;
        b.addEventListener('click', function () { goStep(i); });
        lbSteps.appendChild(b);
      });
    }
    function goStep(i) {
      step = (i + cur.frames.length) % cur.frames.length;
      drawLb();
      track('th_demo_step', { tool_handle: cur.card.dataset.handle, tool_name: cur.name, step: step + 1 });
    }
    function openLb(card) {
      cur = demoData(card);
      if (!cur.frames.length) return;
      step = 0; lastFocus = document.activeElement;
      drawLb();
      lb.hidden = false; lb.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      root.querySelector('[data-th-lb-close]').focus();
      track('th_demo_open', { tool_handle: card.dataset.handle, tool_name: cur.name, position: visibleCards().indexOf(card) + 1, filter_category: state.cat });
      root.dispatchEvent(new CustomEvent('th:demo'));
    }
    function closeLb() {
      if (!lb.classList.contains('is-open')) return;
      lb.classList.remove('is-open'); lb.hidden = true;
      document.body.style.overflow = '';
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }
    root.querySelector('[data-th-lb-close]').addEventListener('click', closeLb);
    root.querySelector('[data-th-lb-next]').addEventListener('click', function () { goStep(step + 1); });
    root.querySelector('[data-th-lb-prev]').addEventListener('click', function () { goStep(step - 1); });
    lb.addEventListener('click', function (e) { if (e.target === lb) closeLb(); });
    document.addEventListener('keydown', function (e) {
      if (!lb.classList.contains('is-open')) return;
      if (e.key === 'Escape') closeLb();
      if (e.key === 'ArrowRight') goStep(step + 1);
      if (e.key === 'ArrowLeft') goStep(step - 1);
    });
    lbGo.addEventListener('click', function () {
      if (cur) track('th_tool_click', { tool_handle: cur.card.dataset.handle, tool_name: cur.name, position: visibleCards().indexOf(cur.card) + 1, filter_category: state.cat, search_term: state.q.trim().toLowerCase(), from: 'demo' });
    });

    // ----- Clicks -----
    grid.addEventListener('click', function (e) {
      var demo = e.target.closest('[data-th-demo]');
      if (demo) { e.preventDefault(); e.stopPropagation(); openLb(demo.closest('[data-th-card]')); return; }
      var link = e.target.closest('[data-th-link]');
      // phones: the screenshot is part of the card, so tapping it opens the tool too
      var shot = !link && isPhone() && e.target.closest('.th__frame');
      if (!link && !shot) return;
      var card = (link || shot).closest('[data-th-card]');
      if (shot) {
        var go = card.querySelector('a.th__body[data-th-link]');
        if (!go) return;
        link = go;
      }
      track('th_tool_click', {
        tool_handle: card.dataset.handle,
        tool_name: card.dataset.name,
        position: visibleCards().indexOf(card) + 1,
        filter_category: state.cat,
        search_term: state.q.trim().toLowerCase()
      });
      if (shot) location.href = link.href;
    });

    var shop = root.querySelector('[data-th-shop]');
    if (shop) shop.addEventListener('click', function () { track('th_shop_click', { link_url: shop.href }); });


    // ----- Email ask (closable card on desktop, pill + bottom sheet on phones) -----
    var ask = root.querySelector('[data-th-ask]');
    var pill = root.querySelector('[data-th-ask-pill]');
    if (ask && pill) (function () {
      var KLAVIYO_COMPANY = 'SCGZFP', KLAVIYO_LIST = 'Si3Bsy', KLAVIYO_REVISION = '2024-10-15';
      var EMAIL_KEYS = ['bt_email', 'ba_tools_email'], FLAG_KEYS = ['ps_unlocked', 'ba_tools_unlocked'];
      var CLOSED_KEY = 'th_ask_closed', EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
      var days = parseInt(ask.dataset.days, 10) || 7;
      var form = ask.querySelector('[data-th-ask-form]'), done = ask.querySelector('[data-th-ask-done]');
      var field = ask.querySelector('[data-th-ask-input]'), err = ask.querySelector('[data-th-ask-err]');
      var go = form.querySelector('button[type="submit"]'), goLabel = go.textContent;
      var shown = false, armed = false, interacted = false;

      function store(k, v) { try { if (v === undefined) return localStorage.getItem(k); localStorage.setItem(k, v); } catch (e) { return null; } }
      function knownEmail() {
        var c = window.BT_CUSTOMER; if (c && c.email) return String(c.email).toLowerCase();
        for (var i = 0; i < EMAIL_KEYS.length; i++) { var v = store(EMAIL_KEYS[i]); if (v) return v; }
        return '';
      }
      function unlocked() { return !!knownEmail() || FLAG_KEYS.some(function (k) { return store(k) === '1'; }); }
      function unlockEverywhere(email) { EMAIL_KEYS.forEach(function (k) { store(k, email); }); FLAG_KEYS.forEach(function (k) { store(k, '1'); }); }
      function closedRecently() { var t = parseInt(store(CLOSED_KEY), 10); return t && (Date.now() - t) < days * 864e5; }

      function showCard(trigger) {
        if (shown) return;
        shown = true;
        pill.hidden = true; ask.hidden = false;
        track('th_ask_view', { trigger: trigger });
      }
      function showPill() { ask.hidden = true; pill.hidden = false; }
      function closeCard() {
        ask.hidden = true; shown = false;
        store(CLOSED_KEY, String(Date.now()));
        showPill();
        track('th_ask_dismiss');
      }
      // Trigger: the demo viewer, halfway down the page, or 8 seconds on the page.
      // Phones/touch: the pill shows right away; the full sheet opens on the same triggers.
      function typing() {
        if (document.querySelector('[data-action="toggle-menu"][aria-expanded="true"]')) return true;   // store menu open
        var a = document.activeElement; return a && /^(INPUT|TEXTAREA|SELECT)$/.test(a.tagName) && !ask.contains(a);
      }
      function maybeShow(trigger) {
        if (!armed || shown || closedRecently()) return;
        if (typing()) { setTimeout(function () { maybeShow(trigger); }, 3000); return; }   // don't cover the search box mid-typing
        showCard(trigger);
      }
      function onScroll() {
        var h = document.documentElement;
        if ((window.scrollY + window.innerHeight) / h.scrollHeight > 0.5) { window.removeEventListener('scroll', onScroll); maybeShow('scroll'); }
      }
      // {svgs} in the ask copy: count the SVG Library's designs (one per SKU) from its index.
      function fillSvgCount() {
        var spots = root.querySelectorAll('[data-th-svg-count]'), url = ask.dataset.svgIndex;
        if (!spots.length || !url) return;
        fetch(url).then(function (r) { return r.ok ? r.json() : null; }).then(function (idx) {
          if (!idx || !Array.isArray(idx.files)) return;
          var skus = {}, n = 0;
          idx.files.forEach(function (f) { if (f.sku && !skus[f.sku]) { skus[f.sku] = 1; n++; } });
          if (n) Array.prototype.forEach.call(spots, function (el) { el.textContent = String(n); });
        }).catch(function (e) { if (DEBUG) console.warn('[tools-hub] svg count failed', e); });
      }
      function arm() {
        if (unlocked()) return;
        armed = true;
        fillSvgCount();
        if (closedRecently()) { showPill(); return; }
        if (isPhone() || !hoverMq.matches) showPill();
        window.addEventListener('scroll', onScroll, { passive: true });
        grid.addEventListener('mouseenter', function (e) { if (e.target.closest && e.target.closest('[data-th-card]')) interacted = true; }, true);
        setTimeout(function () { maybeShow(interacted ? 'hover' : 'timer'); }, 8000);
      }
      ask.querySelector('[data-th-ask-close]').addEventListener('click', closeCard);
      pill.addEventListener('click', function () { shown = false; showCard('pill'); field.focus(); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !ask.hidden && !form.hidden) closeCard(); });

      function subscribe(email) {
        return fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + KLAVIYO_COMPANY, {
          method: 'POST',
          headers: { 'Content-Type': 'application/vnd.api+json', revision: KLAVIYO_REVISION },
          body: JSON.stringify({ data: { type: 'subscription', attributes: {
            custom_source: 'Bearly Tools - Hub',
            profile: { data: { type: 'profile', attributes: { email: email, properties: { first_tool: 'Tools Hub' } } } }
          }, relationships: { list: { data: { type: 'list', id: KLAVIYO_LIST } } } } })
        }).then(function (r) { if (!r.ok) throw new Error('Klaviyo ' + r.status); return r; });
      }
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var email = (field.value || '').trim().toLowerCase();
        if (!EMAIL_RE.test(email)) { err.textContent = 'Enter a full email address, like name@example.com.'; err.hidden = false; field.focus(); return; }
        err.hidden = true; go.disabled = true; go.textContent = 'Sending…';
        var finished = false;
        function finish() {
          if (finished) return; finished = true;
          unlockEverywhere(email);
          form.hidden = true; done.hidden = false;
          go.disabled = false; go.textContent = goLabel;
          track('th_ask_submit');
        }
        var t = setTimeout(finish, 4000);   // fail open, like the tool gate
        subscribe(email).catch(function (e2) { if (DEBUG) console.warn('[tools-hub] subscribe failed', e2); }).then(function () { clearTimeout(t); finish(); });
      });
      var goLink = ask.querySelector('[data-th-ask-go]');
      if (goLink) goLink.addEventListener('click', function () { track('th_tool_click', { tool_handle: 'svg-library', tool_name: 'SVG Library', from: 'ask' }); });

      // Opening the demo viewer counts as an interaction too.
      root.addEventListener('th:demo', function () { maybeShow('demo'); });
      arm();
    })();

    // ----- Breakpoint changes -----
    var wasPhone = isPhone();
    function onLayout() {
      if (isPhone() !== wasPhone) { wasPhone = isPhone(); sortCards(); if (isPhone()) closeLb(); }
      watch();
    }
    if (phoneMq.addEventListener) phoneMq.addEventListener('change', onLayout); else phoneMq.addListener(onLayout);

    apply();
    track('th_view', { tools_count: toolCount, page_location: location.href });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
